<template>
  <div :class="classString" :id="'tab-' + cardIndex">
    <figure class="feature-image">
      <img :src="imagePath" :alt="imageAlt" class="img-fluid" />
      <figcaption class="caption">
        <slot />
      </figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  props: {
    cardIndex: {
      type: Number,
      require: true,
    },
    image: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      required: false,
    },
    isActive: {
      type: Boolean,
      require: false,
    },
  },
  computed: {
    imagePath () {
      return "./img/" + this.image;
    },
    classString () {
      return `tab-pane ${this.isActive ? " active show" : ""}`;
    },
  },
};
</script>

<style>
.tab-pane.active {
  display: flex;
  justify-content: center;
}

.features .feature-image {
  text-align: right;
  max-width: 90%;
}

.feature-image .caption {
  font-size: 12px !important;
  margin-bottom: 0;
  margin-top: 1%;
  text-align: left;
}
</style>
